/**
 * Module dependencies.
 */

import { Title } from 'app/components/atoms/title/title';
import { CrudAdd } from 'app/components/organisms/crud/crud-add';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CrudTemplate } from 'app/components/organisms/crud/form-types';
import { saleFormConfig } from './sales-items/form-sale-config';
import { apiEndpoints } from 'app/core/config/api-endpoints';
import moment from 'moment';
import { resolveAppPath } from 'app/core/utils/url-resolver';
import { appRoutes } from 'app/routes';
import { useParams } from 'react-router-dom';
import { Sale } from 'app/types/sale';

/**
 * Export `SaleCreate` component.
 */

export function SaleCreate(): JSX.Element {
  const [translate] = useTranslation();
  const { userId } = useParams();
  const externalSaleId = useMemo(() => crypto.randomUUID(), []);
  const template = useMemo((): CrudTemplate<Sale> => {
    return {
      add: {
        formFields: saleFormConfig(translate),
        languages: ['*'],
        submitLabel: translate('common.actions.add'),
        normalizeInitialValues: () => {
          return {
            externalSaleId,
            lines: []
          };
        },
        normalizePayload: payload => {
          const cleanPayload = JSON.parse(JSON.stringify(payload));

          cleanPayload.createdAt = moment().toISOString();

          for (const item of cleanPayload.lines ?? []) {
            item.quantity = parseInt(item.quantity, 10);
          }

          console.log(cleanPayload);

          return cleanPayload;
        },
        redirect: resolveAppPath(appRoutes.dashboard.users.detail.sales, { userId }),
        endpoint: apiEndpoints.userSales
      }
    };
  }, [translate, userId, externalSaleId]);

  return (
    <>
      <Title>{translate('users.sales.add.title')}</Title>

      <CrudAdd template={template} />
    </>
  );
}
